import { Skeleton } from '@mui/material';
import React from 'react'

const KYCSkeleton = () => {
  return (
    <div>
      <div className="overflow-x-auto bg-white shadow-md rounded-lg border border-gray-200">
        <table className="w-full text-sm text-left text-gray-700 min-w-[800px]">
          <thead className="text-xs text-gray-500 uppercase bg-gray-50 border-b">
            <tr>
              <th className="px-4 py-3">User ID</th>
              <th className="px-4 py-3">Aadhaar Number</th>
              <th className="px-4 py-3">PAN Number</th>
              <th className="px-4 py-3">Aadhaar Front Image</th>
              <th className="px-4 py-3">Aadhar Back Image</th>
              <th className="px-4 py-3">PAN Image</th>
              <th className="px-4 py-3">Created Date</th>
              <th className="px-4 py-3">Verification</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 2 }).map((_, index) => (
              <tr key={index} className="border-b">
                <td className="px-4 py-3">
                  <Skeleton width={50} />
                </td>
                <td className="px-4 py-3">
                  <Skeleton width={100} />
                </td>
                <td className="px-4 py-3">
                  <Skeleton width={80} />
                </td>
                <td className="px-4 py-3">
                  <Skeleton variant="rectangular" width={80} height={40} />
                </td>
                <td className="px-4 py-3">
                  <Skeleton variant="rectangular" width={80} height={40} />
                </td>
                <td className="px-4 py-3">
                  <Skeleton variant="rectangular" width={80} height={40} />
                </td>
                <td className="px-4 py-3">
                  <Skeleton width={120} />
                </td>
                <td className="px-4 py-3">
                  <Skeleton width={80} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default KYCSkeleton